<template>
  <div>
    <v-app-bar app height="50" dark color="#E2C378">
      <v-toolbar-title style="color: #4c1a65">
        <v-btn icon @click="$router.push('/')" class="mr-2">
          <v-icon color="#4c1a65">mdi-arrow-left</v-icon>
        </v-btn>
        <span style="font-weight: bold">ระบบการจองชื่อสกุล สำหรับงานกาชาด 25{{ showYear }}</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-card justify="center" class="mx-auto mt-5" max-width="800">
      <v-card-title style="background-color: #4c1a65; color: white">
        ระบุข้อมูลส่วนบุคคลเพื่อตรวจสอบ/ยกเลิก ชื่อสกุลที่ได้จองไว้
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="!loginSuccess">
        <v-row class="my-10" justify="center">
          <v-btn tile width="300" x-large class="py-10" @click="loginSuccess = true">
            <v-icon left color="#4c1a65">mdi-card-account-details-outline </v-icon>
            ข้อมูลส่วนบุคคล
          </v-btn>
        </v-row>
        <div class="strike">
          <span>หรือ</span>
        </div>
        <v-row class="my-10" justify="center">
          <v-btn tile width="300" x-large class="py-10" @click="apiDDOPA.LoginDDOPA('', 2)">
            Login by &nbsp;<img src="../assets/logothaid.png" width="40" height="40" />
          </v-btn>
        </v-row>
      </v-card-text>
      <v-card-text v-if="loginSuccess">
        <v-row>
          <v-col>
            <v-text-field
              label="เลขประจำตัวประชาชน"
              v-mask="'#-####-#####-##-#'"
              v-model="inpPID"
              placeholder="เลขประจำตัวประชาชน"
              ref="inpPID"
              clearable
              :rules="[rules.required]"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="หมายเลขหลังบัตรประจำตัวประชาชน"
              placeholder="หมายเลขหลังบัตรประจำตัวประชาชน"
              v-model="inpLaserPID"
              ref="inpLaserPID"
              clearable
              v-mask="'NN#-#######-##'"
              @keyup="uppercase"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="ชื่อตัว"
              placeholder="ชื่อตัว"
              v-model="inpFname"
              ref="inpFname"
              clearable
              @keydown="checkThaionly"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="ชื่อสกุล"
              placeholder="ชื่อสกุล"
              v-model="inpLname"
              ref="inpLname"
              clearable
              @keydown="checkThaionly"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2">
            <v-select
              label="วันเกิด"
              v-model="bDay"
              ref="bDay"
              :items="listDayG"
              item-text="text"
              item-value="value"
              value="{ bDay }"
              placeholder=""
            />
          </v-col>
          <v-col>
            <v-select
              label="เดือนเกิด"
              v-model="bMonth"
              ref="bMonth"
              :items="listMonthGAll"
              item-text="text"
              item-value="value"
              value="{ bMonth }"
              placeholder=""
            />
          </v-col>
          <v-col>
            <v-select
              label="ปีเกิด"
              v-model="bYear"
              ref="bYear"
              :items="listYearG"
              item-text="text"
              item-value="value"
              value="{ bYear }"
              placeholder=""
            />
          </v-col>
        </v-row>
        <v-row>
          <v-spacer />
          <v-col class="px-0">
            <vue-recaptcha
              ref="recaptcha"
              @verify="markRecaptchaAsVerified"
              @expired="onCaptchaExpired"
              :sitekey="sitekey"
              style="transform: scale(0.77)"
            />
          </v-col>
          <v-col class="px-0">
            <v-btn
              color="#4c1a65"
              class="ma-2 white--text"
              :disabled="!(inpPID && inpLaserPID && inpFname && inpLname)"
              v-on:click="searchData()"
              style="max-width: 130px; min-width: 110px"
            >
              <v-icon class="mr-2">mdi-magnify</v-icon>
              ตรวจสอบ
            </v-btn>
          </v-col>
        </v-row>
        <div style="color: red; text-align: right">** กรุณากรอกข้อมูลให้ครบทั้ง 5 ช่อง **</div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogResult" persistent max-width="700">
      <v-card>
        <v-card-title style="background-color: #4c1a65; color: white"> ข้อมูลการจอง </v-card-title>
        <v-card-text class="pt-10" style="font-size: 20px">
          <v-row>
            <v-col><label style="display: contents">ชื่อสกุล : </label> {{ lnameConfirm }} </v-col></v-row
          >
          <v-row>
            <v-col> <label style="display: contents">ความหมาย : </label> {{ lastNameMeanConfirm }} </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label style="display: contents">วันที่จอง : </label> {{ convertDateShow(reserveDatePrint) }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4c1a65" class="white--text" dark @click="dialog = true">ยกเลิกการจอง</v-btn>
          <v-btn color="#4c1a65" class="white--text" dark @click="PrintPDF()">พิมพ์ใบจอง</v-btn>
          <v-btn color="red darken-1" class="white--text" @click="dialogResult = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog content-class="cardDialog" v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title style="background-color: #4c1a65; color: white"> ข้อมูลการจอง </v-card-title>
        <v-card-text class="pt-10" style="font-size: 20px">
          ท่านต้องการ ยกเลิกการจองชื่อสกุล "{{ lnameConfirm }}" ใช่หรือไม่?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4c1a65" class="white--text" @click="deleteReserve()">ใช่</v-btn>
          <v-btn color="red darken-1" class="white--text" @click="dialog = false">ไม่ใช่</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog content-class="cardDialog" v-model="dialogError" persistent max-width="600">
      <v-card>
        <v-card-title style="background-color: #4c1a65; color: white"> {{ dialogHead }} </v-card-title>
        <v-card-text class="pt-10" style="font-size: 20px">{{ statusResult }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4c1a65" class="white--text" @click="dialogError = false"> ปิด </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog content-class="cardDialog" v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <v-card-title style="background-color: #4c1a65; color: white"> ยกเลิกการจองสำเร็จ </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4c1a65" class="white--text" @click="clearData()">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { sync } from "vuex-pathify"
import apiIBD from "../modules/api/apiIBD.js"
import apiCallServices from "../modules/api/apiCallServices"
import printReserve from "../pdf/printReserve.js"
import getFunctionPDF from "../plugins/pdfmake-custom"
import printDoc from "@/plugins/print"
import Swal from "sweetalert2"
import { VueRecaptcha } from "vue-recaptcha"
import apiDDOPA from "../modules/api/apiDDOPA.js"
export default {
  name: "Edit",
  computed: {
    ...sync("*"),
  },
  components: { VueRecaptcha },
  data() {
    return {
      apiDDOPA,
      rules: {
        required: (value) => !!value || "Required.",
      },
      loginSuccess: false,
      snackbar: false,
      textSnackBar: null,
      timeout: 5000,
      showYear: this.$store.state.rcossYM.substring(0, 2),
      curentDate: null,
      flagResult: false,
      inpFname: null,
      inpLname: null,
      bDay: null,
      bMonth: null,
      bYear: null,
      inpPID: null,
      inpLaserPID: null,
      listData: [],
      lnameConfirm: null,
      lastNameMeanConfirm: null,
      pidConfirm: null,
      fullNameConfirm: null,
      docPrint: null,
      reserveDatePrint: null,
      statusResult: null,
      dialogHead: null,
      dialogResult: false,
      dialog: false,
      dialogSuccess: false,
      dialogError: false,
      dialogTest: false,
      // sitekey: '6LcdiwgaAAAAAMhq3i1peVUD_4xXxu2BNJDTPH-l',
      sitekey: "6LfGFz8bAAAAALThf6Rt4nSa9aVaCMmQQsP7Mj4y",
      loginForm: {
        recaptchaVerified: false,
        pleaseTickRecaptchaMessage: "",
      },
    }
  },
  methods: {
    uppercase() {
      if (this.inpLaserPID == undefined) return
      this.inpLaserPID =
        this.inpLaserPID.charAt(0).toUpperCase() + this.inpLaserPID.charAt(1).toUpperCase() + this.inpLaserPID.slice(2)
    },
    searchData: async function () {
      this.flagResult = false
      let sendFname = this.inpFname.trim()
      let sendLname = this.inpLname.trim()
      let sendPID = this.inpPID.trim().replaceAll("-", "")
      let sendBirthDate = this.bYear + "" + this.bMonth + this.bDay
      let sendLaserPID = this.inpLaserPID.trim().replaceAll("-", "")

      if (this.loginForm.recaptchaVerified === false) {
        Swal.fire({
          icon: "error",
          title: "ไม่สามารดำเนินการได้",
          text: "กรุณาระบุตัวตนว่าไม่ใช่โปรแกรมอัตโนมัติ",
          confirmButtonText: "ตกลง",
        })
        return
      }

      try {
        await apiIBD.sendIBDCARD(sendPID, sendLaserPID, sendFname, sendLname, sendBirthDate).then((resData) => {
          this.statusResult = resData
          // this.statusResult = 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง'
          if (this.statusResult === "สถานะปกติ") {
            this.checkPersonal()
          } else {
            Swal.fire({
              icon: "error",
              title: "ข้อมูลบุคคลไม่ถูกต้อง",
              text: this.statusResult,
              confirmButtonText: "ตกลง",
            })
          }
        })
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "ไม่สามารดำเนินการได้",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
        })
      }
    },
    checkPersonal: async function () {
      this.listData = []
      try {
        await apiCallServices.getDataPerson(this.inpPID.replaceAll("-", "")).then((resDataPerson) => {
          // console.log('resDataPerson', resDataPerson)
          if (resDataPerson === 0) {
            // this.statusResult = 'ไม่พบการจองชื่อสกุล ด้วยเลขประจำตัวประชาชนนี้'
            // this.dialogHead = "ข้อมูลการจอง"
            // this.dialogError = true
            Swal.fire({
              icon: "error",
              title: "ข้อมูลการจอง",
              text: "ไม่พบการจองชื่อสกุล ด้วยเลขประจำตัวประชาชนนี้",
              confirmButtonText: "ตกลง",
            })

            return
          }

          this.lnameConfirm = resDataPerson.LastName
          this.pidConfirm = this.inpPID.replaceAll("-", "")
          this.fullNameConfirm = this.inpFname + " " + this.inpLname
          this.lastNameMeanConfirm = resDataPerson.LastNameMean
          this.docPrint = resDataPerson.DoccumentId
          this.reserveDatePrint = resDataPerson.reserveDate
          this.listData = [
            {
              LastName: resDataPerson.LastName,
              LastNameMean: resDataPerson.LastNameMean,
              reserveDate: resDataPerson.reserveDate,
            },
          ]
          this.flagResult = true
          this.dialogHead = "ข้อมูลการจอง"
          this.dialogResult = true
          // console.log('listData', this.listData)
        })
      } catch (error) {
        // this.statusResult = 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง'
        // this.dialogHead = "ไม่สามารดำเนินการได้"
        // this.dialogError = true
        Swal.fire({
          icon: "error",
          title: "ไม่สามารดำเนินการได้",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
        })
      }
    },
    clearData() {
      this.loginForm.recaptchaVerified = false
      this.listData = []
      this.flagResult = false
      this.inpFname = null
      this.inpLname = null
      this.inpPID = null
      this.inpLaserPID = null
      this.statusResult = null
      this.pidConfirm = null
      this.fullNameConfirm = null
      this.docPrint = null
      this.reserveDatePrint = null
      this.lnameConfirm = null
      this.lastNameMeanConfirm = null
      this.dialogError = false
      this.dialogSuccess = false
      this.dialogResult = false
      this.bYear = parseInt(this.curentDate.substring(0, 4))
      this.bMonth = "00"
      this.bDay = "00"
    },
    deleteReserve: async function () {
      try {
        await apiCallServices.cancereReserve(this.lnameConfirm).then((resData) => {
          // console.log('resData', resData)
          // this.dialogSuccess = true
          // this.dialogHead = "ข้อมูลการจอง"
          this.dialog = false
          this.dialogResult = false
          Swal.fire({
            icon: "success",
            title: "ข้อมูลการจอง",
            text: "ยกเลิกการจองสำเร็จ",
            confirmButtonText: "ตกลง",
          }).then((result) => {
            this.clearData()
          })
        })
      } catch (error) {
        // console.log(error)
        // this.statusResult = 'เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง'
        // this.dialogHead = "ไม่สามารดำเนินการได้"
        // this.dialogError = true
        // this.dialog = false
        Swal.fire({
          icon: "error",
          title: "ไม่สามารดำเนินการได้",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
        })
      }
    },
    PrintPDF: async function () {
      var widthScreen = window.innerWidth
      let dataPrint = await printReserve.printReserveLname(
        this.pidConfirm,
        this.fullNameConfirm,
        this.lnameConfirm,
        this.docPrint,
        this.reserveDatePrint,
        this.$store.state.rcossYM
      )
      let option = { margin: [50, 50, 50, 50] }
      if (dataPrint != null) {
        if (widthScreen > 1024) {
          let pdf = await getFunctionPDF.pdfMake.createPdfToDataUrl(dataPrint, option)
          printDoc(pdf)
        } else {
          await getFunctionPDF.pdfMake.createPdf(dataPrint, option).download("ใบจองชื่อสกุล.pdf")
        }
      }
    },
    padString: function (str, max) {
      str = str + ""
      let returnData = str
      for (let i = str.length; i < max; i++) {
        returnData = "0" + returnData
      }
      return returnData
    },
    convertDateShow: function (d) {
      d = d + ""
      let year = d.substring(0, 4)
      let month = d.substring(4, 6)
      let day = d.substring(6, 8)
      let monthDesc = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ]
      return parseInt(day) + " " + monthDesc[parseInt(month)] + " " + year
    },
    checkThaionly(e) {
      this.flagResult = false
      if (e.keyCode === 32 || e.keyCode === 220) {
        // ห้ามกด spacbar  และ \
        e.preventDefault()
      }
      var txtChk =
        "a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|A|B|C|D|E|F|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|1|2|3|4|5|6|7|8|9|0|!|@|#|$|%|^|&|*|(|)|_|-|+|=|[|]|{|}|\|,|;|:|'|/|.|<|>|?|+|๑|๒|๓|๔|฿|๕|๖|๗|๘|๙| |" +
        '"|'
      var aryChkChr = txtChk.split("|")
      var findChar = aryChkChr.find((d) => d === e.key)
      if (findChar !== undefined) {
        e.preventDefault()
      }
    },
    markRecaptchaAsVerified(response) {
      this.loginForm.pleaseTickRecaptchaMessage = ""
      this.loginForm.recaptchaVerified = true
    },
    onCaptchaExpired() {
      this.loginForm.recaptchaVerified = false
    },
  },
  async created() {
    let newDate = new Date()
    let year = newDate.getFullYear()
    if (year < 2500) {
      year = year + 543
    }
    let month = newDate.getMonth()
    month = month + 1
    month = this.padString(month, 2)
    let day = newDate.getDate()
    day = this.padString(day, 2)
    this.curentDate = year + "" + month + "" + day
    this.bYear = year
    this.bMonth = "00"
    this.bDay = "00"

    if (!["", undefined].includes(this.$store.state.DDOPA.token)) {
      this.lnameWrite = this.$store.state.DDOPA.lnameWrite
      this.checkReserve = true
      this.inpPID = this.$store.state.DDOPA.pid
      this.inpFname = this.$store.state.DDOPA.fname
      this.inpLname = this.$store.state.DDOPA.lname
      this.checkPersonal()
    }
  },
  beforeDestroy() {
    this.$store.commit("resetState")
  },
}
</script>
<style scoped></style>
